import { Colors } from './types'

export const baseColors = {
  failure: '#FB1717',
  primary: '#005DA8',
  primaryBright: '#53DEE9',
  primaryDark: '#0582CF',
  secondary: '#513CFF',
  success: '#54AE57',
  warning: '#E4A62E',
  info :  '#AAAAAA',
  error : '#FF3939',
  gradientBackground: 'linear-gradient(96deg, #FF6C21 0%, #403FD8 100%)',
  gradientTab : 'linear-gradient(133.82deg, #513CFF33 13.2%, #23ABD433 100%);',
  gradientBorder : 'linear-gradient(133.82deg, rgba(81, 60, 255, 0.5) 13.2%, rgba(35, 171, 212, 0.5) 100%)',
  link : '#0094FF',
  infoBg : '#77777733',
  warningBg : '#FBAF0033',
  successBg : 'linear-gradient(180deg, rgba(111, 225, 115, 0.1) 0%, rgba(96, 228, 101, 0.1) 93.23%)',
  errorBg : '#FB171726',
  errorBorder: 'rgba(251, 23, 23, 0.4)'
}

export const brandColors = {
  binance: '#F0B90B',
}

export const lightColors: Colors = {
  ...baseColors,
  ...brandColors,
  background: '#FFFFFF',
  backgroundAlt: '#363434',
  backgroundDisabled: '#C5DEE4',
  backgroundDetailPage: 'linear-gradient(to bottom, #0f0f0e 0%,#0f2430 100%)',
  gradientBorder : 'linear-gradient(133.82deg, rgba(81, 60, 255, 0.5) 13.2%, rgba(35, 171, 212, 0.5) 100%)',
  text: '#0B2935',
  textDisabled: '#AAAAAA',
  textSubtle: '#636363',
  borderColor: '#5EB9E5',
  secondary: '#513CFF',
  textTertiary: '#03E7FF',
  secondaryDark: '#96EAB6',
  darkText: '#FFFFFF',
  boxColor: '#F5F5F5',
  blurBorder: '#707070',
  blurButton: '#E4E4E4',
  navyGray: '#0B2935',
  grayText: '#75777A',
  tagBackground: '#E3F2FD',
  tagBorder: '#C8E4F8',
  lightBlue: '#E3F2FD',
  activeState: '#C8E6C9',
  settled: '#E1BEE7',
  modal: '#0F1111',
  overlay: '#0F1111',
  buttonprimary: 'linear-gradient(133.82deg, #513CFF 13.2%, #23ABD4 100%)',
  tabColor: '#0D1620',
  border: 'rgba(233, 233, 233, 0.2)',
  hover: '#9A9EA6',
  gradientColor: 'linear-gradient(180deg, rgba(111, 225, 115, 0.15) 0%, rgba(96, 228, 101, 0.15) 93.23%)',
  borderFooter: '1E1E1E',
  tooltip : '#585858',
  currentRoadMap : 'linear-gradient(133.82deg, rgba(81, 60, 255, 0.5) 13.2%, rgba(35, 171, 212, 0.5) 100%)'
}

export const darkColors: Colors = {
  ...baseColors,
  ...brandColors,
  primary: '#96EAB6',
  primaryDark: '#006468',
  secondary: '#513CFF',
  background: '#000000',
  backgroundDisabled: '#494E4F',
  backgroundAlt: '#363434',
  backgroundDetailPage: 'linear-gradient(to bottom, #0f0f0e 0%,#0f2430 100%)',
  text: '#FFFFFF',
  textDisabled: '#AAAAAA',
  textSubtle: '#E2F6FF',
  borderColor: '#636363',
  textTertiary: '#03E7FF',
  gradientBorder : 'linear-gradient(133.82deg, rgba(81, 60, 255, 0.5) 13.2%, rgba(35, 171, 212, 0.5) 100%)',

  secondaryDark: 'secondary',
  darkText: '#000',
  boxColor: '#F5F5F5',
  blurBorder: '#9E9FAD',
  blurButton: '#E4E4E4',
  navyGray: '#0B2935',
  grayText: '#75777A',
  tagBackground: '#E3F2FD',
  tagBorder: '#C8E4F8',
  lightBlue: '#E3F2FD',
  activeState: '#C8E6C9',
  settled: '#E1BEE7',
  modal: '#0F1111',
  overlay: '#0F1111',
  buttonprimary: 'linear-gradient(133.82deg, #513CFF 13.2%, #23ABD4 100%)',
  tabColor: '#0D1620',
  border: 'rgba(233, 233, 233, 0.2)',
  hover: '#9A9EA6',
  gradientColor: 'linear-gradient(180deg, rgba(111, 225, 115, 0.15) 0%, rgba(96, 228, 101, 0.15) 93.23%)',
  borderFooter: '1E1E1E',
  tooltip : '#585858',
  currentRoadMap : 'linear-gradient(133.82deg, rgba(81, 60, 255, 0.5) 13.2%, rgba(35, 171, 212, 0.5) 100%)'
}
